import { useRef } from 'react';
import styled from 'styled-components';
import { SubmitButton, Container, Heading } from '../../Global/StyledComponents/UserFormStyledComponents';
import LoginForm from './components/LoginForm';
import { BlackTextGlassLogo } from '../../Global/Logos/Logos';
import { isMobile, isTablet } from "react-device-detect";
import useOnScreen from '../../Controllers/hooks/onScreenHook';
import { useNavigate } from 'react-router-dom';
import Footer from '../../Global/Components/Footer';

export const LoginWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: ${(!isMobile || isTablet) ? '100vh' : 'auto'};
    padding: ${(!isMobile || isTablet) ? 0 : '20px 0'};
`;

const LoginContainer = styled.div`
    align-items: center;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    padding: 20px;
    padding-bottom: ${(!isMobile || isTablet) ? '20px' : '200px'};
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
`;

function Login({
    setCustomerProfile,
    setIsAuthenticated,
    setRefreshed,
    setSession,
    setSubscription,
    setUser
}) {
    const containerRef = useRef();
    const loginRef = useRef();
    const isVisible = useOnScreen(loginRef, 1);
    const navigate = useNavigate();

    const handleScroll = () => {
        containerRef?.current?.scrollIntoView({
            block: 'end',
            behavior: "smooth",
        });
    };

    const handleSignUp = (e) => {
        navigate('/signup');
    };
    return (
        <Container
            isMobile={isMobile && !isTablet}
            ref={containerRef}
            style={{ justifyContent: 'space-between', flexDirection: (!isMobile || isTablet) ? 'row' : 'column' }}
        >
            {!isVisible &&
                <SubmitButton
                    onClick={handleScroll}
                    style={{ position: 'fixed', top: 10, right: 10, width: 'fit-content', zIndex: 999}}
                >
                    Sign In
                </SubmitButton>
            }
            <LoginWrapper>
                <LoginContainer
                    ref={loginRef}
                >
                    {(!isMobile || isTablet) &&
                    <>
                        <BlackTextGlassLogo title="Market Reader logo" />
                        {/* <Heading>Sign Up Below to View More</Heading>
                        <SubmitButton style={{ width: 'fit-content' }}
                            onClick={handleSignUp}
                        >
                            Start Your Free Trial
                        </SubmitButton>
                        <br />
                        <Heading style={{ marginBottom: 0 }}>Or</Heading> */}
                    </>
                    }
                    <LoginForm
                        setCustomerProfile={setCustomerProfile}
                        setIsAuthenticated={setIsAuthenticated}
                        setRefreshed={setRefreshed}
                        setSession={setSession}
                        setSubscription={setSubscription}
                        setUser={setUser}
                    />
                </LoginContainer>
            </LoginWrapper>
            {(isMobile && !isTablet) &&
                <LoginWrapper
                    style={{ height: 'auto', position: 'fixed', bottom: 0, zIndex: 999}}
                >
                    <BlackTextGlassLogo title="Market Reader logo" />
                    <Heading>Sign Up Below to View More</Heading>
                    <SubmitButton
                       onClick={handleSignUp}
                    >
                        Start Your Free Trial
                    </SubmitButton>
                </LoginWrapper>
            }
            <Footer />
        </Container>
    );
}
export default Login;
